var image_viewer_default = {
  "fontElementMap": "AAHZW",
  "imageContainer": "EkaYX",
  "expandButton": "_13ggy",
  "expandIcon": "XHBpj",
  "pointer": "MFZ4T",
  "imageWrapper": "DJnJh",
  "imageRatio": "LqEsp",
  "image": "OM2EO",
  "imageOverlay": "s-6su",
  "imagePreload": "p-D3M",
  "imageHighres": "XxOGB",
  "onlyHighRes": "_0Ro7L",
  "image_loading": "_2-ei7"
};
export {
  image_viewer_default as default
};
//# sourceMappingURL=image-viewer-scss.js.map
